import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

interface Props extends RouteProps {
    // tslint:disable-next-line:no-any
    component: any;
    restricted?: boolean;
    gpid?: boolean;
}

const PublicRoute = (props: Props) => {
    const { component: Component, restricted = false, gpid, ...rest } = props;
    const { isAuthenticated } = useAuth();
    return (
        <Route
            {...rest}
            render={routeProps =>
                isAuthenticated && restricted ? (
                    <Redirect to={!gpid ? "/dashboard" : "/minha-saude/vacina"} />
                ) : (
                    <Component {...routeProps} />
                )
            }
        />
    );
};

export default PublicRoute;
